import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["frFlag", "enFlag"];

  connect() {
    const currentLocale = this.getLocaleFromUrl() || "fr";
    this.updateFlagVisibility(currentLocale);
    // La ligne suivante causait l'erreur car cette méthode n'existe pas
    // this.updateCurrentFlagInDropdown(currentLocale);
  }

  selectLanguage(event) {
    const selectedLanguage = event.currentTarget.dataset.language;

    // Construit la nouvelle URL en préservant le chemin après la locale
    const currentPath = window.location.pathname;
    const pathWithoutLocale = currentPath.replace(/^\/(fr|en)/, "");
    const newPath = `/${selectedLanguage}${pathWithoutLocale || "/"}`;

    window.location.href = newPath;
  }

  updateFlagVisibility(locale) {
    // Cache tous les drapeaux d'abord
    this.hideAllFlags();

    // Affiche seulement le drapeau correspondant à la locale actuelle
    switch (locale) {
      case "fr":
        this.frFlagTarget.classList.remove("hidden");
        break;
      case "en":
        this.enFlagTarget.classList.remove("hidden");
        break;
      default:
        // Par défaut, on affiche le français
        this.frFlagTarget.classList.remove("hidden");
    }
  }

  hideAllFlags() {
    this.frFlagTarget.classList.add("hidden");
    this.enFlagTarget.classList.add("hidden");
  }

  getLocaleFromUrl() {
    const pathParts = window.location.pathname.split("/");
    const supportedLocales = ["fr", "en"];
    return supportedLocales.includes(pathParts[1]) ? pathParts[1] : null;
  }
}
